import React, { useEffect, useState } from "react";
import { Card } from "antd";
import { motion } from "motion/react";
import { API_BASE_URL } from "../../Config";
import AdvertisementCard from "../AdvertisementCard";

const Time = () => {
  const [allPages, setAllPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3, duration: 0.8 },
    },
  };

  useEffect(() => {
    const fetchTimeContent = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/allpages?page=time`);
        const json = await res.json();
        setAllPages(json?.data || []);
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTimeContent();

    // ✅ Track screen size changes
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading)
    return <h2 style={{ textAlign: "center", marginTop: 40 }}>Loading…</h2>;

  if (allPages.length === 0)
    return (
      <h2 style={{ textAlign: "center", marginTop: 40 }}>
        No Time Schedule content uploaded.
      </h2>
    );

  return (
    // ✅ Flex row — content left, ad right (ad hidden on mobile via CSS)
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: isMobile ? "10px" : "30px 10px",
      }}
    >
      <motion.div
        style={{
          padding: isMobile ? "12px 8px" : "24px 12px",
          background: "#f9f9f9",
          flex: 1,
          minWidth: 0, // ✅ prevents flex overflow on small screens
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
        }}
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 900,
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          {allPages.map((item) => (
            <motion.div
              key={item._id}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ type: "spring", stiffness: 60, damping: 12 }}
            >
              <Card
                style={{
                  borderRadius: 12,
                  padding: "12px 8px",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                  background: "#ffffff",
                  overflowX: "auto",
                }}
              >
                <div
                  className="page-content"
                  style={{
                    fontSize: "clamp(0.82rem, 2.5vw, 1rem)",
                    lineHeight: 1.7,
                    wordBreak: "break-word",
                    overflowX: "auto",
                  }}
                  dangerouslySetInnerHTML={{ __html: item.content }}
                />
              </Card>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* ✅ Ad hidden on mobile (<=1024px), shown on desktop only */}
      {!isMobile && <AdvertisementCard />}
    </div>
  );
};

export default Time;
